import { learnApiClient } from './clients/learnApiClient';

const completeContent = async (
  userId: string,
  contentId: string | undefined,
  contentType: string,
) => {
  const response = await learnApiClient.post(`workflows/completed-content`, {
    user: userId,
    content: contentId,
    content_type: contentType,
  });

  return response.data;
};

const generateWorkflowLink = (workflowId: string, isV2: boolean) =>
  isV2 ? `/admin/assignments/edit/${workflowId}` : `/pvt/#/edit/workflows/${workflowId}`;

const WorkflowsService = {
  completeContent,
  generateWorkflowLink,
};

export default WorkflowsService;
